import * as m from "mithril";
import { FilterOption, FilterOptionSelection } from '../pages/tripresult/TripSearchFilterModel';
import OutlineButton from "./OutlineButton";
import { MessageManager, MessageProvider } from "../context/AppMessages";
import './FilterSection.css';
import e = require("express");

interface Attrs {
    filterOptionSelections: FilterOptionSelection[],
    messageProvider: MessageProvider,
    onAllFilterClick: () => void,
    onFilterOptionSelected: (option: FilterOption) => void
}

function FilterSection(): m.Component<Attrs> {
    // let showHint: boolean = true;
    return {
        oninit(vnode) {
        },

        onupdate(){
            
            var element = document.getElementById("filterSection");
            if(element){
                element.scrollLeft = (element.scrollWidth)/2 ;     
            }

        },


        view(vnode) {
            return [

                m("div", { class: "d-flex_ py-2 px-3" }, [
                    m("div", { class: "outer-group_", id:"filterSection"}, [
                        m("div", { 
                            class: "d-flex justify-content-end",
                            style: "gap:0.33rem;"
                        }, [
                            vnode.attrs.filterOptionSelections.map(filteredOption =>
                                
                                m(OutlineButton, {
                                    label: filteredOption.option.getLabel(vnode.attrs.messageProvider),
                                    id: filteredOption.option.value,
                                    // label:OptionSelection.option.label,
                                    icon: filteredOption.option.icon,
                                    selected: filteredOption.isSelected,
                                    onSelected: () => {
                                        vnode.attrs.onFilterOptionSelected(filteredOption.option)
                                    }
                                })
                            ),
                        ]),
                    ]),

                    /*
                    m("div", {
                        class: "flex-shrink-0 ml-auto pl-2",
                        style: "position:relative",
                        // id:"tooltip",
                        // onmouseover: () => { showHint = true },
                        // onmouseout: () => { showHint = false },
                    }, [

                        m("div", {
                            class: "d-flex flex-shrink-0 align-items-center filterBtn",
                            onclick: () => {
                                vnode.attrs.onAllFilterClick()
                                // showHint = false;
                            }
                        },
                            
                                [
                                    m("i", { class: "fas fa-filter text-info", style: "font-size:12px" }),
                                    m("span", { class: "pl-1 text-info", style: "font-size:14px" }, vnode.attrs.messageProvider.get("all_filter")),
                                ])
                      

                        // m("span", { class: (showHint) ? "d-block tooltiptext" : "d-none" }, vnode.attrs.messageProvider.get("tooltip")),

                    ])*/


                ])

            ];
        }
    }
};


export default FilterSection;